<template>
  <div>
    <v-dialog v-model="dialog" max-width="1300px">
      <v-card flat tile id="top">
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">mdi-account-multiple-plus-outline</v-icon>방문자 선택
          </v-toolbar-title>
          <v-divider vertical inset class="mx-2"></v-divider>
          <v-icon @click="initialize()">refresh</v-icon>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>

        <div class="pa-8 pt-2 pb-2" style="height:55px;">
          <v-row>
            <v-col cols="12" sm="6" md="6" class="pa-4 pr-0 pl-0">
              <v-text-field v-model="cNowSearchKeyWord" @click:append-outer="SearchCorpWorker()" @keyup.enter="SearchCorpWorker()" append-outer-icon="search" label="이름" placeholder="이름으로 검색하세요." style="max-width:250px;" dense persistent-placeholder hide-details></v-text-field>
            </v-col>
          </v-row>
        </div>

        <div style="height:calc(80vh - 200px);" class="pr-4 pl-4">
          <v-divider></v-divider>
          <v-data-table
            :items-per-page="-1" 
            fixed-header
            :headers="headers"
            :items="Records"
            @click:row="handleClick"
            v-model="selected"
            :single-select="bSinglSelect"
            show-select
            item-key="cCustomId"
            height="calc(80vh - 250px)"
          >
            <template v-slot:item.cCorpNm="{ item }">
              <div v-if="item.cLocal == 'Y'">{{item.cCorpNmKor}}</div>
              <div v-else>{{item.cCorpNmEng}}</div>
            </template>
            <template v-slot:item.cManager="{ item }">
              <v-chip label small :color="getManagerColor(item.cManager)" dark>{{ getManager(item.cManager) }}</v-chip>
            </template>
            <template v-slot:item.cReEduDate="{ item }">
              {{ CalcReEduDate(item.cTestDate) }}
            </template>
            <template v-slot:item.cSuspensionDate="{ item }">
              <div v-if="!item.bCheckableWorker">
                {{CheckPenaltyDate(item.cSuspensionDate)}}
              </div>
            </template>
            <template v-slot:item.data-table-select="{ isSelected,item }">
              <div v-if="item.bCheckableWorker" style="cursor : pointer;">
                <v-icon v-show="isSelected">mdi-checkbox-marked</v-icon>
                <v-icon v-show="!isSelected">mdi-checkbox-blank-outline</v-icon>
              </div>
            </template>
            <template v-slot:no-data>
              <div style="color:black;">{{sMsg}}</div>
            </template>
          </v-data-table>
          <v-divider class="mt-2 mb-4"></v-divider>
        </div>
        <div style="height:65px;" class="d-flex align-center justify-end pr-4 pl-4">
          <v-btn @click="dialog = false;" class="mr-2" text><v-icon class="mr-1">mdi-close</v-icon>닫기</v-btn>
          <v-btn @click="SelectWorker()" class="ml-2" dark><v-icon class="mr-1">mdi-check</v-icon>선택</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BasicInfo from "@/BasicInfo.js";
import axios from "axios"
import EventBus from '@/eventBus.js';
import Util from "../Util.js";


export default {
  components: {
  },
  data: () => ({
    bSinglSelect : false,
    dialog : false,
    cNowSearchKeyWord : "",
    cReqId : "",
    sStartDate : "",
    sEndDate : "",
    sMsg : "",
    zSelectInfo : [],
    selected : [],
    Records: [],
    headers: [
      { class: "font-weight-bold subtitle-2", text: "ID", value: "cCustomNickId", align: "center", width: "70px"},
      { class: "font-weight-bold subtitle-2", text: "이름", value: "cCustomNm", align: "center", width: "70px"},
      { class: "font-weight-bold subtitle-2", text: "이메일", value: "cEmail", align: "center", width: "70px"},
      { class: "font-weight-bold subtitle-2", text: "전화번호", value: "cTel", align: "center", width: "70px"},
      { class: "font-weight-bold subtitle-2", text: "업체명", value: "cCorpNm", align: "center", width: "70px"},
      { class: "font-weight-bold subtitle-2", text: "직책", value: "cLevNm", align: "center", width: "70px"},
      { class: "font-weight-bold subtitle-2", text: "구분", value: "cManager", align: "center", width: "70px"},
      // { class: "font-weight-bold subtitle-2", text: "생년월일", value: "cBirth", align: "center",},
      { class: "font-weight-bold subtitle-2", text: "교육 만료일", value: "cReEduDate", align: "center",},
      { class: "font-weight-bold subtitle-2", text: "출입 정지 만료일", value: "cSuspensionDate", align: "center",},
      { class: "font-weight-bold subtitle-2", text: "비고", value: "cNote", align: "center",width:"120px"},
    ],

  }),
  computed: {
    ...mapState(["CustomInfo","zCustomSort"]),
  },

  created() {
  },

  mounted() {
  },

  props: ['bLongVisit'],

  watch: {
    dialog(val) {
      val || this.CloseDialog();
    }
  },

  methods : {
    ShowDialog(item,zSelectInfo){
      this.dialog = true;
      this.selected = [];
      this.zSelectInfo = [];

      this.sStartDate = item.cStartDate;
      this.sEndDate = item.cEndDate;
      this.cReqId = item.cReqId

      this.zSelectInfo = zSelectInfo
      this.SearchCorpWorker();
    },

    initialize() {
      this.cNowSearchKeyWord = ""
      this.SearchCorpWorker();
    },

    getManager(cManager){
      return this.zCustomSort.find((e) => {return e.value == cManager})?.text
    },

    getManagerColor(cManager){
      return this.zCustomSort.find((e) => {return e.value == cManager})?.color
    },

    CalcReEduDate(cTestDate) {
      if (!cTestDate) {
        return "-"
      } else {
        var date = new Date(cTestDate.substring(0,10));
        var date1 = new Date(date.setMonth(date.getMonth()+6))
        var date2 = new Date(date1.setDate(date1.getDate() - 1))
        return Util.sFormatDate(date2)
      }
    },

    CheckPenaltyDate(cSuspensionDate) {
      if (!cSuspensionDate) {
        return ""
      } else {
        if (new Date(cSuspensionDate) >= new Date()) {
          return cSuspensionDate
        } else {
          return ""
        }
      }
    },

    getNote(item){
      var sNoteMsg = ""

      if (!item.cTestDate){
        sNoteMsg = sNoteMsg + "보안 교육 미 이수"
      } else {
        if (!this.PassTest(item.cTestDate)){
          if (sNoteMsg != "") {
            sNoteMsg = sNoteMsg + ", "
          }

          sNoteMsg = sNoteMsg + "보안 교육 날짜 만료"
        }
      }

      if (this.CheckPenalty(item.cSuspensionStartDate,item.cSuspensionDate,item.cPenaltyType)) {
        if (sNoteMsg != "") {
          sNoteMsg = sNoteMsg + ", "
        }

        sNoteMsg = sNoteMsg + "출입 정지"
      }

      if (item.cLostPassState == "Y") {
        if (sNoteMsg != "") {
          sNoteMsg = sNoteMsg + ", "
        }

        sNoteMsg = sNoteMsg + "분실 신고"
      }

      if (item.cReqState == "Y") {
        if (sNoteMsg != "") {
          sNoteMsg = sNoteMsg + ", "
        }

        sNoteMsg = sNoteMsg + "방문신청 중복"
      }

      if (item.cFileId == "NONE" && this.bLongVisit == true) {
        if (sNoteMsg != "") {
          sNoteMsg = sNoteMsg + ", "
        }

        sNoteMsg = sNoteMsg + "증명사진"
      }

      if (sNoteMsg != "") {
        item.bCheckableWorker = false
      }

      return sNoteMsg
    },

    PassTest(TestDate) {
      var refdate = new Date(TestDate.substring(0,10));
      refdate.setMonth(refdate.getMonth() + 6)
      refdate.setHours(0, 0, 0, 0)

      var now = new Date(this.sEndDate.substring(0,10));
      now.setHours(0, 0, 0, 0)

      if (refdate <= now) {
        return false
      }

      return true
    },
    
    CheckPenalty(cSuspensionStartDate,cSuspensionDate,cPenaltyType) {
      if ((!(cSuspensionStartDate > this.sEndDate || cSuspensionDate < this.sStartDate) && (cPenaltyType == "WC" || cPenaltyType == "C" || cPenaltyType == "CO" || cPenaltyType == "O")) || cPenaltyType == "X") {
        return true
      }

      return false
    },

    SearchCorpWorker() {
      this.Records = [];

      var posData = {
        NowSearchKeyWord : this.cNowSearchKeyWord,
        SiteId : this.CustomInfo.SiteId,
        // CorpId : this.CustomInfo.CorpId,
        // CustomId : this.CustomInfo.CustomId,
        ReqId : this.cReqId,
        VisitStart : this.sStartDate,
        VisitEnd : this.sEndDate,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "SearchCorpWorker", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length > 0) {
              this.bSinglSelect = false
              for (let i = 0; i < res.data.Result.length; i++) {
                let cResultNote = this.getNote(res.data.Result[i])
                res.data.Result[i].bCheckableWorker = true
                res.data.Result[i].cNote = cResultNote

                if (cResultNote != "") {
                  this.bSinglSelect = true;
                  res.data.Result[i].bCheckableWorker = false;
                }

                for (let k = 0; k < this.zSelectInfo.length; k++) {
                  if (res.data.Result[i].cCustomId == this.zSelectInfo[k].CustomId) {
                    this.selected.push(res.data.Result[i])
                  }
                }
              }

              this.Records = res.data.Result
            }  else {
              this.ShowNoResultMsg();
            }
          } else if (res.data.ResultCd == BasicInfo.ERROR_CODE_CHECK_RIGHT_CUSTOM) {
            EventBus.$emit("onShowMsgBox", "정보 조회가 불가 합니다.","소속업체가 변경되었을 수 있습니다.\n새로고침 버튼을 눌러 주세요.");
            this.ShowNoResultMsg();
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    handleClick(value) {
      if (!value.bCheckableWorker) return
      let AddIndex = this.selected.indexOf(value)
      if (AddIndex != -1) {
        this.selected.splice(AddIndex, 1);
      } else {
        this.selected.push(value);
      }
    },

    ShowNoResultMsg() {
      this.sMsg = ""

      setTimeout(() => {
        this.sMsg = "검색된 방문자가 없습니다."
      }, 300);
    },

    SelectWorker() {
      if (this.selected.length == 0) {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.","방문자는 최소 1명 이상 선택하여 주세요.");
        return
      }

      var ZMember = [];
      this.selected.sort(function(a, b) {
        return a.cCustomNm < b.cCustomNm ? -1 : a.cCustomNm > b.cCustomNm ? 1 : 0;
      })

      for (var i = 0; i < this.selected.length; i++){
        ZMember.push({
          sNum : (i + 1),
          CustomId : this.selected[i].cCustomId,
          CustomNm : this.selected[i].cCustomNm,
          LevNm : this.selected[i].cLevNm,
          Email : this.selected[i].cEmail,
          cEmployeeTrainingFileId : this.selected[i].cEmployeeTrainingFileId,
          cEmployeeTrainingDate : this.selected[i].cEmployeeTrainingDate,
          cEmployeeTrainingNum : this.selected[i].cEmployeeTrainingNum,
          cConstructionFileId : this.selected[i].cConstructionFileId,
          cConstructionDate : this.selected[i].cConstructionDate,
          Tel : this.selected[i].cTel,
        });
      }

      this.$emit("onSelect",ZMember);
      this.dialog = false
    },

    CloseDialog(){
      this.selected = [];
      this.cNowSearchKeyWord = "";
    },
  }
}
</script>